import CurrencyReducer from "../reducers/currencyReducer";
import React, {createContext, useContext, useEffect, useReducer} from "react";
import PropTypes from "prop-types";
import {useLocalStorage} from "../../hooks";
import {CURRENCY} from "../../common/constant";
import {useCurrencyCollection} from "../../hooks/useCurrencyCollection";
import {LocaleContext} from "./LocaleProvider";

const initialState = {
    currency: undefined,
    currencyName: "",
    currencies: {},
    currencyNames: {},
    localesMap: {}
};

const CurrencyProvider = ({children}) => {
    const {localeUppercaseUnderscore} = useContext(LocaleContext)[0];
    const [currencyFromLocalStorage] = useLocalStorage(CURRENCY);
    const {currencySelectionCollection} = useCurrencyCollection();
    const [currencyState, currencyDispatch] = useReducer(CurrencyReducer, initialState);

    useEffect(() => {
        if (currencySelectionCollection) {
            currencyDispatch({type: "INIT_CURRENCY", payload: {currencySelectionCollection, localeUppercaseUnderscore, currencyFromLocalStorage}});
        }
    }, [currencySelectionCollection]);

    return (
        <CurrencyContext.Provider value={[currencyState, currencyDispatch]}>
            {children}
        </CurrencyContext.Provider>
    );
};

CurrencyProvider.propTypes = {
    children: PropTypes.any
};

export const CurrencyContext = createContext(initialState);
export default CurrencyProvider;
